<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="6">
          <h1>Gestión de Edificios</h1>
        </b-col>
        <b-col md="6" class="text-right">
          <b-button variant="primary" @click="openModal(null)">
            <feather-icon icon="PlusIcon" class="mr-50" />
            Nuevo Edificio
          </b-button>
        </b-col>
      </b-row>

      <!-- Filtros y Búsqueda -->
      <b-row class="mt-2">
        <b-col md="6">
          <b-form-group>
            <b-input-group>
              <b-form-input
                v-model="filter"
                placeholder="Buscar..."
              />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Tabla de Edificios -->
      <b-table
        striped
        hover
        responsive
        class="mt-2"
        :items="buildings"
        :fields="fields"
        :filter="filter"
      >
        <template #cell(estado)="data">
          <b-badge :variant="data.value ? 'light-success' : 'light-danger'">
            {{ data.value ? 'Activo' : 'Inactivo' }}
          </b-badge>
        </template>
        <template #cell(actions)="data">
          <b-button variant="gradient-primary" class="btn-icon" @click="openModal(data.item)">
            <feather-icon icon="EditIcon" />
          </b-button>
          <b-button variant="gradient-danger" class="btn-icon ml-1" @click="deleteBuilding(data.item)">
            <feather-icon icon="Trash2Icon" />
          </b-button>
        </template>
      </b-table>
    </b-card>

    <!-- Modal de Edición/Creación -->
    <building-modal
      :building-data="selectedBuilding"
      @submit="handleModalSubmit"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BTable, BBadge, BFormGroup, BInputGroup, BFormInput, BInputGroupAppend,
} from 'bootstrap-vue'
import BuildingModal from '@/components/buildings/BuildingModal.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import edificiosService from '@/services/edificiosService'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BuildingModal,
  },
  data() {
    return {
      fields: [
        { key: 'edificioId', label: 'ID', sortable: true },
        { key: 'nombre', label: 'Nombre', sortable: true },
        { key: 'descripcion', label: 'Descripción', sortable: true },
        { key: 'estado', label: 'Estado', sortable: true },
        { key: 'actions', label: 'Acciones' },
      ],
      buildings: [],
      selectedBuilding: null,
      filter: null,
      loading: false,
    }
  },
  async mounted() {
    await this.loadBuildings()
  },
  methods: {
    async loadBuildings() {
      try {
        this.loading = true
        this.buildings = await edificiosService.getAll()
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: 'Error al cargar los edificios',
          },
        })
      } finally {
        this.loading = false
      }
    },
    openModal(item) {
      this.selectedBuilding = item ? { ...item } : null
      this.$bvModal.show('building-modal')
    },
    async handleModalSubmit(data) {
      try {
        if (data.edificioId) {
          // Actualizar edificio existente - excluir edificioId del payload
          const { edificioId, ...updateData } = data
          await edificiosService.update(edificioId, updateData)
        } else {
          // Crear nuevo edificio - excluir edificioId del payload
          const { edificioId, ...createData } = data
          await edificiosService.create(createData)
        }
        
        await this.loadBuildings()
        
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Operación Exitosa',
            icon: 'CheckIcon',
            variant: 'success',
            text: `El edificio se ha ${data.edificioId ? 'actualizado' : 'creado'} correctamente.`,
          },
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: 'Error al procesar la operación',
          },
        })
      }
    },
    async deleteBuilding(item) {
      this.$swal({
        title: '¿Estás seguro?',
        text: '¡No podrás revertir esto!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, ¡elimínalo!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          try {
            await edificiosService.delete(item.edificioId)
            await this.loadBuildings()
            
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Eliminado',
                icon: 'TrashIcon',
                variant: 'success',
                text: 'El edificio ha sido eliminado.',
              },
            })
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                text: 'Error al eliminar el edificio',
              },
            })
          }
        }
      })
    },
  },
}
</script>
